export const ruTranslations = {
  // Navbar
  home: "Главная",
  about: "О нас",
  services: "Услуги",
  blog: "Блог",
  bookAppointment: "Записаться на прием",
  appointment: "Запись",

  // Footer
  rights: "Все права защищены",

  // Common sections
  learnMore: "Узнать больше",
  readMore: "Читать дальше",

  // Hero Section
  heroTitle:
    "Специализированная онкологическая помощь с доктором Викторией Нейман",
  heroSubtitle:
    "Ведущий онколог, стремящийся предоставить персонализированное лечение рака с использованием инновационной медицинской экспертизы и сострадательного лечения.",

  // About Section
  aboutSectionTitle: "Доктор Виктория Нейман",
  aboutSectionSubtitle:
    "Ведущий онколог, специализирующийся на персонализированном лечении рака",
  aboutSectionText1:
    "Доктор Виктория Нейман - уважаемый онколог с более чем 15-летним опытом диагностики и лечения различных видов рака. Её экспертиза охватывает медицинскую онкологию с особым акцентом на рак груди, рак легких и гастроинтестинальные опухоли.",
  aboutSectionText2:
    "После завершения медицинского обучения в медицинском центре Хадасса в Иерусалиме, доктор Нейман специализировалась в онкологии в ведущих учреждениях Европы и США. Она имеет несколько сертификатов и активно участвует в клинических исследованиях для совершенствования протоколов лечения рака.",
  aboutSectionText3:
    "Подход доктора Нейман сочетает инновационную медицинскую экспертизу с сострадательной заботой, обеспечивая каждому пациенту персонализированное лечение, адаптированное к их конкретным потребностям и состоянию.",
  readFullBio: "Читать полную биографию",
  yearsExperience: "30+ лет опыта",

  // Biography Section
  // professionalBiography: "Профессиональная биография",
  biographyText1: "Доктор Виктория Нейман является ведущим специалистом в области клинической онкологии, внутренней медицины и радиотерапии с более чем 30-летним опытом работы. Она возглавляет отделение онкологического стационара в онкологическом центре Давидов, входящем в состав медицинского центра Рабина (Бейлинсон).",
  biographyText2: "Её области специализации включают внутреннюю медицину, клиническую онкологию и радиотерапию, с особым фокусом на уро-онкологические опухоли и рак молочной железы. Она лечит широкий спектр заболеваний, включая рак почек, простаты, мочевого пузыря и яичек.",
  biographyText3: "Доктор Нейман окончила медицинский университет в Советском Союзе и специализировалась по внутренней медицине, клинической онкологии и радиотерапии в медицинском центре Рабина. Она преподает в медицинской школе Саклера при Тель-Авивском университете и в школе медсестер.",
  biographyText4: "Она активно участвует во многих клинических исследованиях, включая международные исследования рака молочной железы, почек, мочевой системы и простаты. Её исследования способствуют развитию онкологического лечения и пониманию заболевания.",
  biographyText5: "Доктор Нейман является членом ведущих профессиональных ассоциаций, включая Общество клинической онкологии и радиотерапии, Израильское общество внутренней медицины, Израильскую урологическую ассоциацию и Европейское общество медицинской онкологии (ESMO).",
  biographyText6: "Её пациенты отмечают её профессионализм, человечность и исключительную доступность.",
  biographyText7: "Доктор Нейман считается центральной фигурой в области онкологии в Израиле, сочетая глубокие клинические знания с гуманным и эмпатическим подходом. Она руководит медицинскими и исследовательскими командами и вкладывает много сил в обучение следующего поколения врачей.",
  biographyText8: "Кроме того, она участвует в профессиональных конференциях, читает лекции и публикует статьи в своей области специализации. Она стремится обеспечить высочайший уровень медицинской помощи, предоставляя личное внимание и поддержку своим пациентам.",
  biographyText9: "Доктор Нейман говорит на иврите, английском и русском языках, предлагая медицинские услуги широкому кругу пациентов.",
  biographyText10: "Её подход к лечению пациентов сочетает передовые медицинские знания с глубоким состраданием, обеспечивая каждому пациенту индивидуальное лечение, адаптированное к их конкретным потребностям и обстоятельствам.",

  // Services Section
  ourServices: "Наши услуги",
  servicesSubtitle:
    "Доктор Нейман предлагает комплексный набор онкологических услуг от диагностики до лечения и долгосрочного планирования ухода.",
  viewAllServices: "Посмотреть все услуги",

  // Testimonials Section
  patientTestimonials: "Отзывы пациентов",
  testimonialsSubtitle:
    "Читайте отзывы наших пациентов о их опыте лечения у доктора Виктории Нейман.",

  // Appointment Section
  scheduleAppointment: "Записаться на прием",
  appointmentText:
    "Сделайте первый шаг к персонализированному лечению рака, записавшись на прием к доктору Виктории Нейман. Наша команда готова помочь вам и предоставить необходимую поддержку на протяжении всего пути.",
  callUs: "Позвоните нам",
  emailUs: "Напишите нам",
  officeHours: "Часы работы",
  bookOnline: "Записаться онлайн",
  orCallDirectly: "Или позвоните напрямую",
  clinicLocation: "Местоположение клиники",
  easyAccess: "Удобный доступ",

  // Blog Section
  blogSectionTitle: "Последние медицинские новости",
  blogSectionSubtitle:
    "Оставайтесь в курсе последних исследований, вариантов лечения и здоровья от доктора Виктории Нейман.",
  viewAllPosts: "Посмотреть все записи",

  // News Section
  inTheNews: "В новостях",
  newsSubtitle:
    "Вклад доктора Виктории Нейман в онкологические исследования и уход за пациентами в медицинских публикациях и СМИ.",
  readOriginal: "Читать оригинальную статью",

  // Footer
  quickLinks: "Быстрые ссылки",
  contactInfo: "Контактная информация",
  officeHoursFooter: "Часы работы",
  privacyPolicy: "Политика конфиденциальности",
  termsOfService: "Условия обслуживания",
  adminLogin: "Вход для администраторов",

  // Services page
  servicesHeroTitle: "Наши услуги",
  servicesHeroSubtitle:
    "Доктор Виктория Нейман предлагает комплексные онкологические услуги с акцентом на персонализированное лечение и сострадательную заботу.",

  // CTA Section
  readyForNextStep: "Готовы к следующему шагу?",
  scheduleCTA:
    "Запишитесь на консультацию с доктором Викторией Нейман, чтобы обсудить ваше состояние и изучить лучшие варианты лечения для ваших конкретных нужд.",

  // FAQ Section
  frequentlyAskedQuestions: "Часто задаваемые вопросы",
  faqSubtitle:
    "Найдите ответы на часто задаваемые вопросы о наших онкологических услугах",
  dontSeeQuestion: "Не нашли здесь ваш вопрос? Свяжитесь с нами напрямую.",
  contactUs: "Свяжитесь с нами",

  // Appointment Page
  scheduleAnAppointment: "Записаться на прием",
  appointmentDescription:
    "Запросите прием к доктору Виктории Нейман. Мы свяжемся с вами в ближайшее время, чтобы подтвердить время вашего приема.",
  requestAnAppointment: "Запросить прием",

  // Appointment Form
  fullName: "Полное имя",
  email: "Электронная почта",
  phoneNumber: "Номер телефона",
  date: "Дата",
  time: "Время",
  selectDate: "Выберите дату",
  selectTime: "Выберите время",
  reasonForVisit: "Причина визита",
  selectReason: "Выберите причину",
  additionalInformation: "Дополнительная информация (необязательно)",
  additionalInfoPlaceholder:
    "Пожалуйста, поделитесь любой дополнительной информацией о вашем состоянии или конкретных беспокойствах.",
  submitRequest: "Отправить запрос",
  submitting: "Отправка...",

  // Office Hours and Contact Info
  contactInformation: "Контактная информация",
  phone: "Телефон",
  address: "Адрес",
  mondayThursday: "Воскресенье - Четверг",
  friday: "Пятница",
  saturday: "Суббота",
  sunday: "Воскресенье",
  closed: "Закрыто",
  officeHoursSchedule: "Воскресенье-Четверг: 9:00-17:00",

  // Form placeholders
  namePlaceholder: "Иван Иванов",
  emailPlaceholder: "your@email.com",
  phonePlaceholder: "+7 (555) 123-4567",

  // Appointment Reasons
  initialConsultation: "Первичная консультация",
  followUp: "Повторный визит",
  treatmentDiscussion: "Обсуждение лечения",
  secondOpinion: "Второе мнение",
  testResultsReview: "Обзор результатов тестов",
  other: "Другое",

  skipToContent: "Перейти к основному содержанию",

  // Service titles and descriptions
  cancerDiagnosis: "Диагностика рака",
  cancerDiagnosisDesc:
    "Комплексные диагностические услуги, включая передовую визуализацию, биопсии и генетическое тестирование, чтобы определить точный характер и стадию вашего рака.",
  personalizedTreatment: "Персонализированные планы лечения",
  personalizedTreatmentDesc:
    "Индивидуальные стратегии лечения, созданные специально для вашего состояния, с учетом типа вашего рака, стадии, генетического профиля и личных факторов здоровья.",
  chemotherapy: "Химиотерапия",
  chemotherapyDesc:
    "Администрирование и управление протоколами химиотерапии с тщательным мониторингом и поддерживающим уходом, чтобы минимизировать побочные эффекты и максимизировать эффективность.",
  immunotherapy: "Иммунотерапия",
  immunotherapyDesc:
    "Передовые методы иммунотерапии, которые привлекают вашу иммунную систему для борьбы с раком, со специализированной экспертизой в новейших протоколах.",
  targetedTherapy: "Таргетная терапия",
  targetedTherapyDesc:
    "Методы точной медицины, направленные на специфические генетические мутации или белки, участвующие в росте и распространении вашего рака.",
  survivorshipCare: "Уход за выжившими",
  survivorshipCareDesc:
    "Долгосрочный последующий уход и планирование благополучия для выживших после рака, учитывая как физические, так и психологические аспекты жизни после рака.",

  // Research Section
  selectedPublications: "Выбранные публикации",
  researchInterests: "Научные интересы",
  publication1:
    'Neiman V, et al. (2022) "Эффективность и токсичность гипофракционированной лучевой терапии у пациентов с раком груди." Текущие онкологические вопросы.',
  publication2:
    'Neiman V, et al. (2022) "Реальный опыт с высокодозовыми или плотнодозными антрациклинами и таксанами для пациентов с тройным негативным раком груди." Текущие онкологические вопросы.',
  publication3:
    'Neiman V, et al. (2021) "Результаты лечения пациентов с тройным негативным раком груди паллиативным бевацизумабом." Онколог.',
  publication4:
    'Neiman V, et al. (2020) "Эффективность и токсичность плотнодозного доксорубицина и циклофосфамида (ddAC) у пациентов с раком груди: опыт одного центра." Клинический рак груди.',
  publication5:
    'Neiman V, et al. (2019) "Эффективность и токсичность блокаторов рецепторов ангиотензина II в адъювантной терапии для пациентов с раком груди: систематический обзор." Журнал клинической онкологии.',

  personalizedCancer: "Персонализированное лечение рака",
  personalizedCancerDesc:
    "Разработка персонализированных подходов к лечению на основе генетического и молекулярного профиля опухолей.",
  immunotherapyOptimization: "Оптимизация иммунотерапии",
  immunotherapyOptimizationDesc:
    "Повышение эффективности и снижение побочных эффектов иммунотерапии при различных типах рака.",
  cancerInElderly: "Рак у пожилых пациентов",
  cancerInElderlyDesc:
    "Специализированные подходы к лечению рака у гериатрических пациентов, балансируя эффективность и качество жизни.",
  combinationTherapy: "Комбинированные протоколы лечения",
  combinationTherapyDesc:
    "Исследование синергетических эффектов комбинирования различных методов лечения для улучшения результатов.",

  // Accessibility Widget
  accessibilityOptions: "Настройки доступности",
  fontSize: "Размер шрифта",
  brightness: "Яркость",
  highContrast: "Высокая контрастность",
  on: "Вкл.",
  off: "Выкл.",
  resetAll: "Сбросить все",
  adjustFontSize: "Настроить размер шрифта",
  adjustBrightness: "Настроить яркость экрана",
  subject: "перевозчик",
  subjectPlaceHolder: "Пожалуйста, предоставьте подробную информацию о вашем запросе",
  contactDescription: "У вас есть вопросы или вам нужно связаться с доктором Викторией Нейман? Мы здесь, чтобы помочь.",
  // Treatment Process Section
  treatmentProcessTitle: "Наш процесс лечения",
  treatmentProcessSubtitle:
    "Доктор Нейман следует структурированному подходу, чтобы обеспечить комплексный уход за каждым пациентом",
  initialConsultationStep: "Первичная консультация",
  initialConsultationDesc:
    "Тщательный обзор вашей медицинской истории, симптомов и беспокойств, чтобы установить базовое понимание вашего состояния.",
  comprehensiveDiagnosisStep: "Комплексная диагностика",
  comprehensiveDiagnosisDesc:
    "Передовые диагностические процедуры, включая визуализацию, лабораторные тесты и биопсии, чтобы точно определить тип и стадию вашего рака.",
  personalizedTreatmentPlanningStep: "Персонализированное планирование лечения",
  personalizedTreatmentPlanningDesc:
    "Разработка индивидуальной стратегии лечения, учитывающей ваш специфический профиль рака, общее состояние здор  вья и личные предпочтения.",
  treatmentImplementationStep: "Реализация лечения",
  treatmentImplementationDesc:
    "Тщательное администрирование выбранных методов лечения с регулярным мониторингом и корректировками по мере необходимости.",
  followUpCareStep: "Последующий уход",
  followUpCareDesc:
    "Постоянные оценки для отслеживания вашего прогресса, управления побочными эффектами и внесения необходимых изменений в ваш план лечения.",
  survivorshipPlanningStep: "Планирование выживаемости",
  survivorshipPlanningDesc:
    "Долгосрочное планирование ухода, направленное на предотвращение рецидивов, мониторинг поздних эффектов лечения и поддержку вашего возвращения к здоровью.",

  // FAQ questions and answers
  faqCancerTypes: "Какими видами рака специализируется доктор Нейман?",
  faqCancerTypesAnswer:
    "Доктор Нейман специализируется на лечении широкого спектра видов рака, с особой экспертизой в области рака груди, рака легких, гастроинтестинальных раков и лимфом.",
  faqTreatmentTime: "Сколько времени обычно занимает процесс лечения?",
  faqTreatmentTimeAnswer:
    "Продолжительность лечения рака значительно варьируется в зависимости от типа и стадии рака, а также от конкретного подхода к лечению. В ходе вашей консультации доктор Нейман предоставит вам подробный график, основанный на вашем индивидуальном случае.",
  faqTeam: "Работает ли доктор Нейман с мультидисциплинарной командой?",
  faqTeamAnswer:
    "Да, доктор Нейман сотрудничает с комплексной командой медицинских специалистов, включая хирургов, радиационных онкологов, патологов, медсестер, диетологов и специалистов по психическому здоровью, чтобы обеспечить холистический уход за каждым пациентом.",
  faqFirstAppointment: "Что мне нужно принести на первую встречу?",
  faqFirstAppointmentAnswer:
    "Пожалуйста, принесите свои медицинские записи, включая предыдущие результаты тестов, сканирования и патологические отчеты. Также принесите список текущих лекарств, страховую информацию и любые вопросы, которые у вас могут быть.",
  faqTelemedicine: "Доступны ли консультации по телемедицине?",
  faqTelemedicineAnswer:
    "Да, доктор Нейман предлагает телемедицинские приемы в соответствующих ситуациях, таких как последующие консультации и определенные виды обсуждений лечения.",

  // Patient Stories
  patientStoriesTitle: "Истории пациентов",
  patientStoriesDescription:
    "Пациенты делятся своими переживаниями и путешесвиями с доктром Нейманом и полученными лечениями.",
  allStories: "Все истории",
  breastCancer: "Рак груди",
  lungCancer: "Рак легких",
  gastrointestinal: "Гастроинтестинальный",
  lymphoma: "Лимфома",
  noStoriesFound: "Истории не найдены",
  noVideosFound: "Видео отзывы не найдены",
  backToVideos: "Вернуться к видео",
  videoTestimonialsDescription: "Посмотрите, как мы изменили жизни наших пациентов",
  featuredStories: "Рекомендуемые истории",
  ourBlog: "Наш блог",
  latestNews: "Последние новости",
  allPosts: "Все посты",
  categories: "Категории",
  search: "Поиск",
  recentPosts: "Недавние посты",
  popularTags: "Популярные теги",
  noPostsFound: "Посты не найдены",
  servicesTitle: "Услуги",
  checkOutOurServices: "Ознакомьтесь с нашими услугами",
  noServicesFound: "Услуги не найдены",
  contactTitle: "Контакт",
  getInTouch: "Свяжитесь с нами",
  contactForm: "Контактная форма",
  location: "Местоположение",
  send: "Отправить",
  appointmentTitle: "Записаться на прием",
  bookYourAppointment: "Запишитесь на прием",
  selectADate: "Выберите дату",
  selectATime: "Выберите время",
  selectAReason: "Выберите причину",
  additionalMessage: "Дополнительное сообщение",
  submit: "Отправить",
  reason: "Причина",
  yourAppointmentHasBeenBooked: "Ваша запись на прием была успешно забронирована",
  thankYou: "Спасибо!",
  weWillContactYouSoon: "Мы свяжемся с вами в ближайшее время",
  backToHomePage: "Вернуться на главную страницу",
  name: "Имя",
  success: "Успех",
  error: "Ошибка",
  warning: "Предупреждение",
  info: "Информация",
  login: "Войти",
  logout: "Выйти",
  dashboard: "Панель управления",
  adminDashboard: "Панель управления администратора",
  blogManagement: "Управление блогом",
  videoManagement: "Управление видео",
  patientStoryManagement: "Управление историями пациентов",
  serviceManagement: "Управление услугами",
  newsManagement: "Управление новостями",
  userManagement: "Управление пользователями",
  settings: "Настройки",
  users: "Пользователи",
  role: "Роль",
  actions: "Действия",
  edit: "Редактировать",
  delete: "Удалить",
  create: "Создать",
  save: "Сохранить",
  cancel: "Отменить",
  title: "Заголовок",
  category: "Категория",
  datePublished: "Дата публикации",
  excerpt: "Выдержка",
  content: "Содержание",
  author: "Автор",
  newPost: "Новый пост",
  searchPosts: "Поиск постов...",
  sortBy: "Сортировать по",
  newestFirst: "Сначала новые",
  oldestFirst: "Сначала старые",
  titleAZ: "Заголовок (А-Я)",
  titleZA: "Заголовок (Я-А)",
  noBlogPostsFound: "Блог посты не найдены",
  confirmDeletion: "Подтвердить удаление",
  areYouSureYouWantToDelete: "Вы уверены, что хотите удалить",
  thisActionCannotBeUndone: "Это действие нельзя отменить.",
  deletePost: "Удалить пост",
  editBlogPost: "Редактировать блог пост",
  createBlogPost: "Создать блог пост",
  enterPostTitle: "Введите заголовок поста",
  selectCategory: "Выберите категорию",
  briefSummaryOfThePost: "Краткое содержание поста",
  fullBlogPostContent: "Полное содержание блог поста",
  mediaVideos: "Медиа видео",
  manageVideosThatAppear: "Управление видео, которые появляются в разделе Медиа появления на странице О нас.",
  addVideo: "Добавить видео",
  updateVideo: "Обновить видео",
  addANewVideo: "Добавить новое видео в раздел медиа появлений.",
  updateTheVideoDetails: "Обновить детали видео.",
  videoTitle: "Название видео",
  videoSource: "Источник видео",
  videoURL: "URL видео",
  pleaseFillInAllRequiredFields: "Пожалуйста, заполните все обязательные поля",
  noVideosAvailable: "Нет доступных видео",
  patientStoriesManagement: "Управление историями пациентов",
  createPatientStory: "Создать историю пациента",
  editPatientStory: "Редактировать историю пациента",
  patientName: "Имя пациента",
  patientPosition: "Должность пациента",
  patientContent: "Содержание пациента",
  patientRating: "Рейтинг пациента",
  patientImageURL: "URL изображения пациента",
  patientFullStory: "Полная история пациента",
  patientDiagnosis: "Диагноз пациента",
  patientTreatmentJourney: "Путь лечения пациента",
  patientVideoURL: "URL видео пациента",
  patientFeatured: "Рекомендуемый пациент",
  noPatientStoriesFound: "Истории пациентов не найдены",
  serviceManagementTitle: "Управление услугами",
  createService: "Создать услугу",
  editService: "Редактировать услугу",
  serviceTitle: "Название услуги",
  serviceDescription: "Описание услуги",
  serviceIcon: "Иконка услуги",
  serviceImageURL: "URL изображения услуги",
  noServicesAvailable: "Нет доступных услуг",
  newsManagementTitle: "Управление новостями",
  createNewsArticle: "Создать новостную статью",
  editNewsArticle: "Редактировать новостную статью",
  newsTitle: "Название новости",
  newsSource: "Источник новости",
  newsDate: "Дата новости",
  newsExcerpt: "Выдержка новости",
  newsURL: "URL новости",
  newsImageURL: "URL изображения новости",
  noNewsArticlesFound: "Новостные статьи не найдены",
  
  // Admin section
  messages: "Сообщения",
  messagePlaceHolder: "Пожалуйста, предоставьте подробную информацию о вашем запросе",
  messagesManagement: "Управление сообщениями",
  recentMessages: "Последние сообщения",
  messageDetails: "Детали сообщения",
  allMessages: "Все сообщения",
  noMessages: "Сообщения не найдены",
  markAsRead: "Отметить как прочитанное",
  markAsUnread: "Отметить как непрочитанное",
  messageFrom: "Сообщение от",
  sent: "Отправлено",
  reply: "Ответить",
  deleteMessage: "Удалить сообщение",
  faqsManagement: "Управление часто задаваемыми вопросами",
  addFaq: "Добавить FAQ",
  editFaq: "Редактировать FAQ",
  question: "Вопрос",
  answer: "Ответ",
  contentManagement: "Управление контентом",
  footerManagement: "Управление футером",
  contactInfoManagement: "Управление контактной информацией",
  biographyManagement: "Управление биографией",
  editContent: "Редактировать контент",
  contentUpdated: "Контент успешно обновлен",
  contentCreated: "Контент успешно создан",
  contentDeleted: "Контент успешно удален",
  confirmDelete: "Вы уверены, что хотите удалить этот элемент?",
  addNew: "Добавить новый",
  emptyState: "Элементы не найдены. Нажмите 'Добавить новый', чтобы создать один.",
  
  
  // Treatment section
  treatment: "Лечение",
  videoTestimonials: "Видеоотзывы",
  featuredStoriesDescription:
    "Особые истории, подчеркивающие всеобъемлющий и личный подход доктора Неймана к лечению рака.",
  readFullStory: "Читать полную историю",
  watchVideo: "Смотреть видео",
  diagnosis: "Диагноз",
  treatmentJourney: "Путь лечения",
  patientStory: "История пациента",
  shareStory: "Поделиться своей историей",
  fullStory: "Полная история",
  videoTestimonial: "Видеоотзыв",

  // Appointment management translations
  appointmentManagement: "Управление записями",
  editAppointment: "Редактировать запись",
  deleteAppointment: "Удалить запись",
  confirmDeleteAppointment: "Вы уверены, что хотите удалить эту запись?",
  appointmentUpdated: "Запись успешно обновлена",
  appointmentDeleted: "Запись успешно удалена",
  noAppointments: "Записи еще не назначены",

  // Video management translations
  editVideo: "Редактировать видео",
  deleteVideo: "Удалить видео",
  confirmDeleteVideo: "Вы уверены, что хотите удалить это видео?",
  videoAdded: "Видео успешно добавлено",
  videoUpdated: "Видео успешно обновлено",
  videoDeleted: "Видео успешно удалено",
  // Admin general
  viewAll: "Посмотреть все",
  scheduleNew: "Назначить новое",
  status: "Статус",
  patient: "Пациент",
  contact: "Контакт",
  dateTime: "Дата и время",

  //BiographySection
  professionalBiography: "Профессиональная биография",

  //About
  aboutDoctorHeader: "О докторе Виктории Нейман",

  // WhatsApp QR Code
  whatsappQR: 'Отсканируйте для чата в WhatsApp',
  openWhatsApp: 'Открыть чат в WhatsApp',
};
